import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import {
  feedbackTypeListSchema,
  type FeedbackType,
  type CreateFeedbackTypePayload,
  type UpdateFeedbackTypePayload,
} from '../types/feedbackType.types';

export const feedbackTypeQueryKeys = {
  all: () => ['feedback-types'] as const,
  list: () => [...feedbackTypeQueryKeys.all(), 'list'] as const,
};

export const feedbackTypesQueryOptions = () =>
  queryOptions({
    queryKey: feedbackTypeQueryKeys.list(),
    queryFn: async (): Promise<FeedbackType[]> => {
      const res = await apiClient.get(API.feedback.types);
      return feedbackTypeListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export async function createFeedbackType(payload: CreateFeedbackTypePayload): Promise<void> {
  await apiClient.post(API.feedback.types, payload);
}

export async function updateFeedbackType(
  id: number,
  payload: UpdateFeedbackTypePayload,
): Promise<void> {
  await apiClient.patch(`${API.feedback.types}/${id}`, payload);
}

export async function deleteFeedbackType(id: number): Promise<void> {
  await apiClient.delete(`${API.feedback.types}/${id}`);
}
